import { failureKind } from './api-error';

const MAX_RETRIES = 3;

/**
 * Whether a failed request could plausibly succeed if re-sent unchanged.
 *
 * A 4xx is the server's definitive answer to this exact request — re-sending
 * it only holds the UI in a skeleton for the length of the backoff before the
 * same error renders. The exceptions are 408 (request timeout) and 429
 * (`RATE_LIMITED`, which the server pairs with `retryAfterSeconds`): both say
 * "not now", not "never". 5xx and network failures stay retryable. The
 * classification itself lives in `failureKind`.
 */
export function isTransientError(err: unknown): boolean {
  return failureKind(err) === 'transient';
}

/** Default react-query `retry` predicate: transient failures, up to 3 retries. */
export function shouldRetry(failureCount: number, err: unknown): boolean {
  return isTransientError(err) && failureCount < MAX_RETRIES;
}
